import { render } from "./DeleteNote.vue?vue&type=template&id=b56da5b8"
import script from "./DeleteNote.vue?vue&type=script&lang=js"
export * from "./DeleteNote.vue?vue&type=script&lang=js"
script.render = render

export default script